export const locales = {
	btnText: 'S’identifier avec FranceConnect'
};
